/* LIBERHAUS · дизайн 2026 — только поведение; вся разметка приходит с сервера (секции lh2-*).
   Меню телефона, ролики по видимости (≤2 на десктопе, ≤1 на телефоне, видимые на 60 %), плитки по наведению,
   лента роликов на весь экран. Save-Data и «меньше движения» — только обложки, ничего не играет само. */
(function () {
  var d = document;

  // ── меню на телефоне ──
  var mn = d.getElementById('lh2-mnav');
  function setMenu(open) {
    if (!mn) return;
    mn.hidden = !open;
    d.body.classList.toggle('mnav-open', open);
    d.querySelectorAll('[data-mnav-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    var f = open ? mn.querySelector('[data-mnav-close]') : d.querySelector('[data-mnav-open]');
    if (f && (open || mn.dataset.wasOpen)) f.focus();
    mn.dataset.wasOpen = open ? '1' : '';
  }

  // ── ролики ──
  var quiet = navigator.webdriver || (navigator.connection && navigator.connection.saveData) ||
    (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var cap = window.matchMedia && matchMedia('(max-width:749px)').matches ? 1 : 2;
  var playing = [];
  function stop(v) { v.pause(); var i = playing.indexOf(v); if (i > -1) playing.splice(i, 1); }
  function play(v) {
    if (playing.indexOf(v) > -1) return;
    while (playing.length >= cap) stop(playing[0]);
    playing.push(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () { stop(v); });
  }
  var io = (!quiet && 'IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (en) { if (en.intersectionRatio >= 0.6) play(en.target); else stop(en.target); });
  }, { threshold: [0, 0.6] }) : null;
  function wire(root) {
    root.querySelectorAll('.vid__play').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var v = b.parentElement.querySelector('video');
        if (v.paused) play(v); else stop(v);
      });
    });
    if (io) root.querySelectorAll('.vid video, video[data-auto]').forEach(function (v) {
      // петля первого экрана — только после загрузки кадра под ней (кадр — LCP, ролик — потом)
      var h = v.closest('.hero'), im = h && h.querySelector('picture img');
      if (im && !im.complete) { var go = function () { io.observe(v); }; im.addEventListener('load', go, { once: true }); im.addEventListener('error', go, { once: true }); }
      else io.observe(v);
    });
  }
  wire(d);
  window.LH2 = { wire: wire, stop: stop, io: io }; // для показа вариантов (блок lh-preview ниже)
  // >>> фидбэк 26.10 п.6: кнопка ролика — Pause, пока ролик играет, Play на паузе (значок и aria-label). По событиям видео:
  // автозапуск по видимости, остановка соседним роликом и нажатие — одинаково
  var vbP = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4.5v15l12-7.5z" fill="currentColor"/></svg>',
    vbS = '<svg viewBox="0 0 24 24" aria-hidden="true" style="margin-left:0"><path d="M6.5 4.5h4v15h-4zM13.5 4.5h4v15h-4z" fill="currentColor"/></svg>';
  function vbSync(v) {
    var b = v.parentElement && v.parentElement.querySelector('.vid__play'); if (!b) return;
    var on = !v.paused && !v.ended, k = on ? '1' : '0'; if (b.getAttribute('data-on') === k) return;
    b.setAttribute('data-on', k); b.setAttribute('aria-label', on ? 'Pause creator video' : 'Play creator video');
    var s = b.querySelector('span'); if (s) s.innerHTML = on ? vbS : vbP;
  }
  ['play', 'playing', 'pause', 'ended', 'emptied'].forEach(function (t) {
    d.addEventListener(t, function (e) { var v = e.target; if (v && v.tagName === 'VIDEO') vbSync(v); }, true);
  });
  // <<< фидбэк 26.10 п.6

  // плитки линий: ролик по наведению на десктопе, на телефоне — обложка
  d.querySelectorAll('.tile video[data-hover]').forEach(function (v) {
    var t = v.closest('.tile');
    t.addEventListener('mouseenter', function () { if (!quiet) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } });
    t.addEventListener('mouseleave', function () { v.pause(); });
  });

  // ── лента роликов на весь экран ──
  var reel = null, opener = null;
  function closeReel() {
    if (!reel) return;
    reel.classList.remove('is-open');
    reel.setAttribute('aria-hidden', 'true');
    reel.querySelectorAll('video').forEach(stop);
    d.body.style.overflow = '';
    reel = null;
    if (opener) opener.focus();
  }
  function openReel(btn) {
    var r = d.getElementById(btn.getAttribute('data-reel-open'));
    if (!r) return;
    var list = r.querySelector('.reel__list'), tpl = r.querySelector('template');
    playing.slice().forEach(stop); // ролики страницы под лентой не играют
    if (!list.childElementCount && tpl) { list.appendChild(tpl.content.cloneNode(true)); wire(list); }
    r.classList.add('is-open');
    r.setAttribute('aria-hidden', 'false');
    d.body.style.overflow = 'hidden';
    reel = r; opener = btn;
    var x = r.querySelector('.reel__x'); if (x) x.focus();
  }

  d.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-mnav-open]')) { setMenu(true); return; }
    if (t.closest('[data-mnav-close]')) { setMenu(false); return; }
    var o = t.closest('[data-reel-open]');
    if (o) { openReel(o); return; }
    if (t.closest('.reel__x')) closeReel();
  });
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (reel) closeReel();
    else if (mn && !mn.hidden) setMenu(false);
  });
})();

/* >>> lh-preview (показ вариантов ?preview=1, 23.10; пишет pv_js.py) — без режима показа ничего не делает.
   Группы — <script type="application/json" data-pv-group> (snippets/lh-preview.liquid), варианты — data-pv-<ключ> на <html>
   (CSS) и слоты [data-pv-slot] ← <template data-pv-tpl data-pv-value>. */
(function () {
  var d = document, html = d.documentElement;
  if (!html.classList.contains('lh-preview')) return;
  var L = window.LH2 || {}, groups = [], seen = {};
  function get(k) { try { return sessionStorage.getItem('lhPv:' + k); } catch (e) { return null; } }
  function put(k, v) { try { sessionStorage.setItem('lhPv:' + k, v); } catch (e) {} }
  function esc(x) { return String(x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  d.querySelectorAll('script[data-pv-group]').forEach(function (el) {
    try { var g = JSON.parse(el.textContent); if (g && g.k && !seen[g.k]) { seen[g.k] = 1; groups.push(g); } } catch (e) {}
  });
  if (!groups.length) return;
  function cur(g) { var v = get(g.k); return v && g.v.some(function (o) { return o[0] === v; }) ? v : g.d; }
  function swap(k, v) {
    d.querySelectorAll('[data-pv-slot="' + k + '"]').forEach(function (slot) {
      var id = slot.getAttribute('data-pv-id');
      if (!slot._pvDef) { slot._pvDef = d.createElement('template'); slot._pvDef.innerHTML = slot.innerHTML; }
      var t = d.querySelector('template[data-pv-tpl="' + id + '"][data-pv-value="' + v + '"]') || slot._pvDef;
      if (slot._pvCur === t || (!slot._pvCur && t === slot._pvDef)) { slot._pvCur = t; return; }
      slot.querySelectorAll('video').forEach(function (x) { if (L.stop) L.stop(x); if (L.io) L.io.unobserve(x); });
      slot.innerHTML = ''; slot.appendChild(t.content.cloneNode(true)); slot._pvCur = t;
      if (L.wire) L.wire(slot);
    });
  }
  function apply(k, v) { html.setAttribute('data-pv-' + k, v); swap(k, v); }
  groups.forEach(function (g) { apply(g.k, cur(g)); });
  var p = d.createElement('div'), open = false;
  try { open = sessionStorage.getItem('lhPvOpen') === '1'; } catch (e) {}
  p.className = 'pvar'; p.setAttribute('role', 'group'); p.setAttribute('aria-label', 'Preview only: page variants');
  function label(g, v) { var o = g.v.filter(function (x) { return x[0] === v; })[0]; return o ? o[1] : v; }
  function draw() {
    p.classList.toggle('is-open', open);
    var head = '<div class="pvar__h"><button type="button" class="pvar__t" aria-expanded="' + open + '">Variants ' + (open ? '▴' : '▾') + '</button>' +
      (open ? '<a href="?preview=0">Exit preview</a>' : '<span class="pvar__s">' + groups.map(function (g) { return esc(g.t) + ' ' + esc(label(g, cur(g))); }).join(' · ') + '</span>') + '</div>';
    p.innerHTML = head + (open ? groups.map(function (g) {
      var c = cur(g);
      return '<div><b>' + esc(g.t) + '</b>' + g.v.map(function (o) {
        return '<button type="button" data-k="' + esc(g.k) + '" data-v="' + esc(o[0]) + '" aria-pressed="' + (o[0] === c) + '">' + esc(o[1]) + '</button>';
      }).join('') + '</div>';
    }).join('') : '');
  }
  p.addEventListener('click', function (e) {
    if (e.target.closest('.pvar__t')) { open = !open; try { sessionStorage.setItem('lhPvOpen', open ? '1' : '0'); } catch (x) {} draw(); return; }
    var b = e.target.closest('button[data-k]'); if (!b) return;
    put(b.getAttribute('data-k'), b.getAttribute('data-v')); apply(b.getAttribute('data-k'), b.getAttribute('data-v')); draw();
  });
  draw(); d.body.appendChild(p);
})();
/* <<< lh-preview */
